import { Fragment } from "react";
import { Link } from "react-router-dom";
import Footer from "../component/layout/footer";
import Header from "../component/layout/header";
import Rating from "../component/sidebar/rating";

const danceTutorList = [
    {
        imgUrl: "assets/images/Dance/BeginnerDance.png",
        imgAlt: "Beginner Dance Tutor",
        tutorName: "Meera Sharma",
        expertise: "Beginner & Bollywood Dance Trainer",
        experience: "6+ Years Experience",
        students: "140+ Students Trained",
        reviewCount: "15 reviews",
        profile: "/beginner-dance-tutor",
        btnText: "View Profile",
    },
    {
        imgUrl: "assets/images/Dance/ClassicalDance.png",
        imgAlt: "Classical Dance Tutor",
        tutorName: "Ananya Reddy",
        expertise: "Kuchipudi & Bharatanatyam Specialist",
        experience: "12+ Years Experience",
        students: "250+ Students",
        reviewCount: "20 reviews",
        profile: "/classical-dance-tutor",
        btnText: "View Profile",
    },
    {
        imgUrl: "assets/images/Dance/HipHop.png",
        imgAlt: "Hip Hop Tutor",
        tutorName: "Jake Wilson",
        expertise: "Hip Hop & Freestyle Dance",
        experience: "8+ Years Experience",
        students: "170+ Students",
        reviewCount: "11 reviews",
        profile: "/hiphop-tutor",
        btnText: "View Profile",
    },
    {
        imgUrl: "assets/images/Dance/StageDance.png",
        imgAlt: "Stage Performance Tutor",
        tutorName: "Simran Kaur",
        expertise: "Stage Performance & Choreography",
        experience: "9+ Years Experience",
        students: "200+ Students",
        reviewCount: "16 reviews",
        profile: "/stage-dance-tutor",
        btnText: "View Profile",
    },
];

const PerformingArts = () => {
    return (
        <Fragment>
            <Header />

            <div
                className="course-section padding-tb section-bg"
                style={{ backgroundColor: "#ecc1a1ff" }}
            >
                <div className="container" style={{ marginTop: 60 }}>
                    <div className="row g-4">

                        {/* ---------- LEFT SIDE ADS ---------- */}
                        <div className="col-lg-3 col-md-4">
                            <div className="ads-sidebar">
                                <h5 className="mb-3 text-center">🎭 Sponsored</h5>
                                <div className="ad-item mb-3">
                                    <img
                                        src="assets/images/art/theatreAd1.png"
                                        alt="Ad 1"
                                        className="w-100 rounded shadow-sm"
                                    />
                                </div>
                                <div className="ad-item mb-3">
                                    <img
                                        src="assets/images/art/danceAd1.png"
                                        alt="Ad 2"
                                        className="w-100 rounded shadow-sm"
                                    />
                                </div>
                                <div className="ad-item">
                                    <img
                                        src="assets/images/art/musicAd1.png"
                                        alt="Ad 3"
                                        className="w-100 rounded shadow-sm"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* ---------- RIGHT SIDE CONTENT ---------- */}
                        <div className="col-lg-9 col-md-8">
                            <div className="section-wrapper">

                                <div className="row g-4 justify-content-center row-cols-xl-2 row-cols-md-2 row-cols-1">
                                    {danceTutorList.map((tutor, i) => (
                                        <div className="col" key={i}>
                                            <div className="course-item shadow-sm rounded">
                                                <div className="course-inner">

                                                    {/* Tutor Image */}
                                                    <div className="course-thumb">
                                                        <img src={tutor.imgUrl} alt={tutor.imgAlt} />
                                                    </div>

                                                    {/* Tutor Info */}
                                                    <div className="course-content">
                                                        <div className="course-category">
                                                            <div className="course-reiew">
                                                                <Rating />
                                                                <span className="ratting-count">
                                                                    {" "}{tutor.reviewCount}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        <Link to={tutor.profile}>
                                                            <h4>{tutor.tutorName}</h4>
                                                        </Link>

                                                        <p style={{ color: "black", margin: "5px 0" }}>
                                                            💃 {tutor.expertise}
                                                        </p>

                                                        <p style={{ color: "black", margin: "5px 0" }}>
                                                            ⭐ {tutor.experience}
                                                        </p>

                                                        <p style={{ color: "black", margin: "5px 0" }}>
                                                            👥 {tutor.students}
                                                        </p>

                                                        {/* Footer */}
                                                        <div className="course-footer">
                                                            <div></div>
                                                            <div className="course-btn">
                                                                <Link to={tutor.profile} className="lab-btn-text">
                                                                    {tutor.btnText}{" "}
                                                                    <i className="icofont-external-link"></i>
                                                                </Link>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </Fragment>
    );
};

export default PerformingArts;
